/**
 * The Design affordance a native page offers.
 *
 * Deliberately a button and not a link. Design mode happens IN PLACE: the native
 * page stays mounted and keeps the data it already fetched, so the designer edits
 * the real page rather than a preview of it. Navigating to a separate designer
 * route would mean re-fetching the page's data there, which would move data
 * fetching and permission checks out of the native page — the one thing the
 * architecture says must not happen.
 *
 * Renders nothing when the viewer may not design, so a page can mount it
 * unconditionally.
 */
import { LayoutGrid } from "lucide-react";

export default function DesignButton({
  canDesign,
  onClick,
  testId,
  label = "Design",
  title = "Open the Application Designer for this page",
}) {
  if (!canDesign) return null;
  return (
    <button
      type="button"
      data-testid={testId}
      className="ad-bar__btn"
      title={title}
      onClick={onClick}
    >
      <LayoutGrid className="h-3.5 w-3.5" aria-hidden="true" />
      {label}
    </button>
  );
}
